App.vue.setComponent(require('@components/Product/ProductDetail.vue').default);
App.vue.setComponent(require('@components/Product/ProductKits/ProductKits.vue').default);
App.vue.setComponent(require('@components/Product/AboutProduct.vue').default);
App.vue.setComponent(require('@components/sliders/SameGoods.vue').default);
App.vue.setComponent(require('@components/Product/sliders/PackageBanner.vue').default);
App.vue.setComponent(require('@components/sliders/CheckedGoods.vue').default);
